<template>
  <div class="text-gray-800 text-3 my-auto flex mt-4">
    <div class="col-3 input-effect w-full">
      <input
        class="effect-16 w-full"
        type="text"
        placeholder="Enter your field name*"
        v-model="annotationField.fieldName"
      />
      <span class="focus-border w-full"></span>
    </div>
    <div class="col-3 input-effect w-full pl-2">
      <LvColorpicker
        placeholder="Choose your color"
        v-model="annotationField.fieldColor"
        clearable
      />
    </div>
  </div>
</template>
<script>
import LvColorpicker from "lightvue/color-picker";
export default {
  data() {
    return {
    };
  },

  watch: {},

  methods: {},
  created() {},

  components: {
    LvColorpicker: LvColorpicker,
  },
  props: {
    annotationField: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
